import { render, staticRenderFns } from "./MainLedgerPrintCard5.vue?vue&type=template&id=143bfca6&scoped=true"
import script from "./MainLedgerPrintCard5.vue?vue&type=script&lang=js"
export * from "./MainLedgerPrintCard5.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerPrintCard5.vue?vue&type=style&index=0&id=143bfca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143bfca6",
  null
  
)

export default component.exports